export const email = [
  {
    id: "purpose",
    type: "dropdown",
    choices: [
      "Compose a new email",
      "Reply to an existing email",
      "Forward an email",
      "Request information",
      "Confirm details",
      "Send a follow-up",
    ],
  },
  {
    id: "recipient",
    type: "dropdown",
    choices: [
      "Colleague",
      "Client/Customer",
      "Manager/Supervisor",
      "Friend/Family",
      "Other",
    ],
  },
  {
    id: "tone",
    type: "dropdown",
    choices: [
      "Formal/Professional",
      "Informal/Casual",
      "Urgent",
      "Friendly",
      "Apologizing",
      "Thankful",
    ],
  },
  {
    id: "grammarStyle",
    type: "checkbox",
    choices: [
      {
        value: "Grammar",
        title: "Grammar",
        description: "Check for grammar and spelling errors",
      },
      {
        value: "Clarity",
        title: "Clarity",
        description: "Improve sentence structure and clarity",
      },
      {
        value: "Enhancements",
        title: "Enhancements",
        description: "Enhance the overall tone and style",
      },
    ],
  },
  {
    id: "emailContent",
    type: "textarea",
    placeholder:
      "Provide the existing email content or outline the key points for a new email",
  },
  {
    id: "callToAction",
    type: "textarea",
    placeholder:
      "What do you want the recipient to do after reading the email?",
  },
];
